import { thisExpression } from '@babel/types';
import React, { Component } from 'react';
import { Row, Tabs, Tab, Card, Image, Button, Col, Table } from 'react-bootstrap';
import './shortnotes.scss';
import SyllabusPdfTable from './syllabusPdfTable';
import UserRestrictionAlertInstitute from '../home/UserRestrictionAlertInstitute';
import * as Cookies from "es-cookie";
import LockSimple from './LockSimple.png'

class PhysicsShortNotes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showPdf: false,
            pdfUrl: "",
            userRestionModalShow: false
        }
        /*function Pdf(props) {
            document.addEventListener("contextmenu", (event) => {
                event.preventDefault();
              });
            }*/

        this.data = [
            {
                name: 'MOTION IN STRAIGHT LINE ',
                url: "https://rizee.in/econtent/short_notes/PHY3_5694_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'MOTION IN PLANE ',
                url: "https://rizee.in/econtent/short_notes/PHY4_5544_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'UNITS AND MEASUREMENT',
                url: "https://rizee.in/econtent/short_notes/PHY2_5442_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'LAWS OF MOTION',
                url: "https://rizee.in/econtent/short_notes/PHY5_2839_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'WORK ,ENERGY AND POWER',
                url: "https://rizee.in/econtent/short_notes/PHY6_4107_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'GRAVITATION',
                url: "https://rizee.in/econtent/short_notes/PHY9_8825_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'OSCILLATION',
                url: "https://rizee.in/econtent/short_notes/PHY8_6938_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'SYSTEM OF PARTICLE AND ROTATIONAL MOTION',
                url: "https://rizee.in/econtent/short_notes/PHY7_1241_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'MECHNICAL PROPERTIES OF SOLIDS',
                url: "https://rizee.in/econtent/short_notes/PHY10_7606_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'MECHNICAL PROPERTIES OF FLUIDS',
                url: "https://rizee.in/econtent/short_notes/PHY11_5105_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'THERMAL PROPERTIES OF MATTER',
                url: "https://rizee.in/econtent/short_notes/PHY12_2127_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'THERMODYNAMICS',
                url: "https://rizee.in/econtent/short_notes/PHY13_7481_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'KINETIC THEORY',
                url: "https://rizee.in/econtent/short_notes/PHY14_5893_SHRT.pdf",
                value: "View Notes",
                year: "First Year"
            },
            {
                name: 'WAVES',
                url: "https://rizee.in/econtent/short_notes/PHY15_7811_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'RAY OPTICS AND OPTICAL INSTRUMENTS',
                url: "https://rizee.in/econtent/short_notes/PHY16_1919_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'WAVE OPTICS',
                url: "https://rizee.in/econtent/short_notes/PHY17_6563_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'ELECTRIC CHARGES AND FIELD ',
                url: "https://rizee.in/econtent/short_notes/PHY18_7132_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },

            {
                name: 'ELECTRO STATIC POTENTIAL AND CAPACITANCE',
                url: "https://rizee.in/econtent/short_notes/PHY19_9838_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'CURRENT ELECTRICITY',
                url: "https://rizee.in/econtent/short_notes/PHY20_4148_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            // {
            //     name: 'CURRENT ELECTRICITY-2',
            //     url: "",
            //     value:"Coming Soon",
            //     year:"Second Year"
            // },
            {
                name: 'MOVING CHARGES AND MAGNETISM',
                url: "https://rizee.in/econtent/short_notes/PHY21_6798_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'MAGNETISM AND MATTER',
                url: "https://rizee.in/econtent/short_notes/PHY22_4822_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'SEMICONDUCTOR ELECTRONICS :MATERIALS,DEVICES AND SIMPLE CIRCUIT',
                url: "https://rizee.in/econtent/short_notes/PHY22_4822_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'COMMUNICATION SYSTEM',
                url: "https://rizee.in/econtent/short_notes/PHY30_3622_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'DUAL NATURE OF MATTER AND RADIATION',
                url: "https://rizee.in/econtent/short_notes/PHY26_1432_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'ELECTROMAGNETIC INDUCTION',
                url: "https://rizee.in/econtent/short_notes/PHY23_7872_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'ELECTROMAGNETIC WAVE',
                url: "https://rizee.in/econtent/short_notes/PHY25_1234_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'ALTERNATING CURRENT',
                url: "https://rizee.in/econtent/short_notes/PHY24_5024_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'ATOMS',
                url: "https://rizee.in/econtent/short_notes/PHY27_3965_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            },
            {
                name: 'NUCLIE',
                url: "https://rizee.in/econtent/short_notes/PHY28_9322_SHRT.pdf",
                value: "View Notes",
                year: "Second Year"
            }

        ]
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            this.isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
    }
    modalaFun = (info, index) => {
        console.log(info)
        let isStudentUserValid = ""
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        console.log(isStudentUserValid)
        console.log(isStudentUserValid.current_plan_id)
        console.log(Cookies.get("institution_id"))

        return (
            this.handlePdfView(info.url)
        )

    }

    handlePdfView = (url) => {
        console.log("physics")
        console.log(url)
        this.setState({
            showPdf: !this.state.showPdf,
            pdfUrl: url
        });
    }

    render() {
        return (


            <Row>
                {
                    !this.state.showPdf && this.data.map((cardInfo, index) => {
                        return (
                            <Col sm={6} className="mt-4">
                                <div class="bg_white">
                                    <Row>
                                        <Col sm={8}>
                                            <h6 class="title mt-2">{cardInfo.name} </h6>

                                        </Col>
                                        <Col sm={4}>
                                            {
                                                cardInfo.value === "Coming Soon"
                                                    ? <h6 className="float-right viewNotesComingSoonCls" onClick={() => this.modalaFun(cardInfo, index)}>{cardInfo.value}</h6> :
                                                    <h6 className="float-right viewNotesCls" onClick={() => this.modalaFun(cardInfo, index)}>{cardInfo.value}</h6>
                                            }

                                        </Col>
                                    </Row>
                                </div>
                            </Col>

                            /*<Col>
                                <Card className="card_main mt-8">
                                    <Card.Body className="d-flex justify-content-between">
                                        <Card.Title className="card_title">{cardInfo.name}</Card.Title>
                                        {
                                            (index > 3 && Cookies.get("institution_id") == 30 && this.isStudentUserValid.current_plan_id == "23") ? (<img src={LockSimple} alt="lock image" className="lockActions"></img>) : (<div/>)
                                        }
                                        <Button variant="info" size="md" className="button content-style" onClick={() => this.modalaFun(cardInfo,index)}>{cardInfo.value}</Button>
                                        
                                    </Card.Body>
                                </Card>
                            </Col>*/
                        )
                    })
                }
                <SyllabusPdfTable
                    showPdf={this.state.showPdf}
                    pdfUrl={this.state.pdfUrl}
                />
                <UserRestrictionAlertInstitute
                    show={this.state.userRestionModalShow}
                    onHide={() => this.setState({ userRestionModalShow: false })}
                />
            </Row>
        )
    }
}
export default PhysicsShortNotes;